// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pointer{display:flex;justify-content:center;align-items:center;position:fixed;z-index:100;width:12px;height:12px;top:50%;left:50%;opacity:0;border-radius:50%;background-color:#ffe6ed;visibility:hidden;pointer-events:none;mix-blend-mode:exclusion;transition:opacity .3s;transform-origin:center center}.pointer__arrow{width:22.5%;height:auto;transform:scale(0);transform-origin:center center}.pointer--hidden{opacity:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
